import { useSelector } from "react-redux";
import { setFilterOptionsAndSave, toggleTruckFilter, toggleTrailerFilter, toggleDriverFilter, clearVehicleDriverFilters } from "./index";
import { selectFilterOptions, selectTruckFilterIds, selectTrailerFilterIds, selectDriverFilterIds } from "./selectors";
import { useMyTeams } from "../../data/teams/hooks";
import { useAppDispatch } from "../../../redux-store";
import * as selectors from "./selectors";
import * as types from "./types";
import { selectVehiclesVisibleToUser } from "../../data/trailers/selectors";
import { selectDriversVisibleForUser } from "../../data/drivers/selectors";

export const useRouteView = (routeId: string | null) => {
  const localState = useSelector(selectors.selectRouteVisibleCargoIds(routeId));
  return { items: localState };
};

export const useTeamFilters = (filterType: types.FilterType) => {
  const dispatch = useAppDispatch();
  const selectedTeams = useSelector(selectFilterOptions(filterType));
  const teams = useMyTeams();
  const isTeamSelected = (id: string) => selectedTeams.includes(id);
  const setTeamSelected = (input: { teamId: string; enabled: boolean }) => {
    dispatch(setFilterOptionsAndSave({ ...input, filterType }));
  };
  return { teams, isTeamSelected, setTeamSelected };
};

export const useRouteFilterOptions = () => useTeamFilters("routes");
export const useCargoFilterOptions = () => useTeamFilters("cargos");

export const useRouteTruckFilters = () => {
  const dispatch = useAppDispatch();
  const allVisibleTrailers = useSelector(selectVehiclesVisibleToUser);
  const trucks = allVisibleTrailers.filter((t) => t.powered);
  const selectedIds = useSelector(selectTruckFilterIds);
  return {
    trucks,
    selectedIds,
    toggleTruck: (id: string) => dispatch(toggleTruckFilter(id)),
  };
};

export const useRouteTrailerFilters = () => {
  const dispatch = useAppDispatch();
  const allVisibleTrailers = useSelector(selectVehiclesVisibleToUser);
  const trailers = allVisibleTrailers.filter((t) => !t.powered);
  const selectedIds = useSelector(selectTrailerFilterIds);
  return {
    trailers,
    selectedIds,
    toggleTrailer: (id: string) => dispatch(toggleTrailerFilter(id)),
  };
};

export const useRouteDriverFilters = () => {
  const dispatch = useAppDispatch();
  const drivers = useSelector(selectDriversVisibleForUser);
  const selectedIds = useSelector(selectDriverFilterIds);
  return {
    drivers,
    selectedIds,
    toggleDriver: (id: string) => dispatch(toggleDriverFilter(id)),
  };
};

export const useClearVehicleDriverFilters = () => {
  const dispatch = useAppDispatch();
  return () => dispatch(clearVehicleDriverFilters());
};
